module.exports = __webpack_public_path__ + "img/eg.d89ba362.svg";